import OSXTitleBar from '@/components/OSXTitleBar'
import { GalleryLayout, useViewMode } from '../shared/useViewMode'
import GalleryTopBar from './GalleryTopBar'
import { Invite, VideoGrid, TestVideoGrid } from './modes'

export function Gallery() {
    const mode = useViewMode()

    return (
        <div className="relative w-full h-full grid grid-rows-[min-content_min-content_1fr]">
            <div>{!mode.fullscreen && <OSXTitleBar />}</div>
            <GalleryTopBar />
            {renderMode(mode.galleryLayout)}
        </div>
    )
}

function renderMode(mode: GalleryLayout) {
    switch (mode.name) {
        case 'invite':
            return <Invite />
        case 'grid':
            return <VideoGrid page={mode.page} />
        case 'test-grid':
            return <TestVideoGrid numVideos={mode.numVideos} page={mode.page} />
        case 'pinned':
            return <VideoGrid pinnedVideo={mode.pinnedVideo} />
        default:
            return <></>
    }
}
